var newBuildArtists = {
    limit: 8,
    init: function() {
        if($('#artist-creation-buttons').length>0) {
            $('#artist-creation-buttons .btn').click(newBuildArtists.artistPageCreationsButtonPress);
            $('#artist-creation-buttons .btn.active').click();
        }

        if($('#artists-tab-buttons').length>0) {
            $('#artists-tab-buttons .btn').click(newBuildArtists.artistsPageTabButtonPress);

            hashTab.stripHash();
            console.log(hashTab.hashTab,hashTab.requestParams);
            if(hashTab.hashTab === null) {
                $("#loadButton").click();
            } else {
                newBuildArtists.abcLetter = hashTab.requestParams.char;
                var button = $('#artists-tab-buttons .btn[data-tab="'+hashTab.hashTab+'"]');
                if(button.length == 1) {
                    button.click();
                }
            }

        }

        if($('.artist-page').length>0) {
            $('.artist_images .toggle').click(newBuildArtists.artistPageImageToggle);
        }

    },
    abcLetter: 'A',
    abcSuffix: 'is_featured',
    switchLetter: function(letter) {
        newBuildArtists.abcLetter = letter;

        $('.block-abc .letter-badge').html('?');
        $('.block-abc .letters .active').removeClass("active");

        var url = $('.block-abc').data('request-url') + (newBuildArtists.abcSuffix ? '/' + newBuildArtists.abcSuffix : '');
        hashTab.hashUpdate(0, letter, newBuildArtists.abcSuffix, newBuildArtists.limit, '');

        $.ajax({
            url: url,
            method: "POST",
            dataType: "json",
            data: {
                abcfilter: letter,
            },
            success: function( resp ) {
                if(resp.data && resp.data.html) {
                    $('.block-abc .names').html(resp.data.html);
                    letter = resp.data.letter;
                    $('.block-abc .letters .nav-link[data-letter="'+letter+'"]').addClass("active");
                    $('.block-abc .letter-badge').html(letter);
                } else {
                    console.log(resp);
                }

            }
        });

    },
    onSearch: function() {
        console.log('onSearch');
        if(newBuildArtists.searchReq != $("#searchReq").val().trim()) {
            newBuildArtists.searchReq = $("#searchReq").val().trim();
            newBuildArtists.pageCnt = 0;
        }
        var button = $("#loadButton");
        $(button).show();
        $(button).prop('disabled', false);
        newBuildArtists.loadMore(button);
        return false;
    },
    pageCnt: 0,
    searchReq: '',
    loadMore: function(button) {
        newBuildArtists.pageCnt++;
        $(button).prop('disabled', true);
        var limit = $(button).data("limit");
        var url = $(button).data("request");
        $.ajax({
            url: url,
            method: "GET",
            dataType: "json",
            data: {
                lazyLoad: '',
                limit: limit,
                page: newBuildArtists.pageCnt,
                searchReq: newBuildArtists.searchReq,
                newbuild: true,
            },
            success: function( resp ) {
                if(resp.data) {
                    if(newBuildArtists.pageCnt == 1) {
                        $('.block-artists-featured .cards').html(resp.data.html);
                    } else {
                        $('.block-artists-featured .cards').append(resp.data.html);
                    }
                    if(resp.data.more) {
                        $(button).prop('disabled', false);
                    } else {
                        $(button).hide();
                    }
                    console.log('loadMore 1');
                } else {
                    console.log(resp);
                }

            }
        });
    },
    artistsPageTabButtonPress: function(event) {
        event.preventDefault();
        newBuildArtists.pageCnt=0;
        var data = {
            limit: newBuildArtists.limit,
            grid: 'newbuild',
            view: 'newbuild',
        };
        $('#loadButton').data('limit', newBuildArtists.limit);
        $('#loadButton').data('request-data', data);
        $('#loadButton').data('pagecnt', '0');
        $('#loadButton').data('request', $(event.target).data('request'));

        hashTab.hashUpdate(0, newBuildArtists.abcLetter, $(event.target).data('tab'), newBuildArtists.limit, '');

        loadMore.click($('#loadButton'));

        newBuildArtists.setActiveButton(event.target);

        newBuildArtists.abcSuffix = $(event.target).data('tab');
        newBuildArtists.switchLetter('A');

        //console.log('artistsPageTabButtonPress', event.target);
    },
    artistPageCreationsButtonPress: function(event) {
        event.preventDefault();
        var data = {
            limit: 4,
            grid: 'newbuild',
            view: 'newbuild',
        };
        $('#loadButton').data('limit', '4');
        $('#loadButton').show();
        $('#loadButton').data('request-data', data);
        $('#loadButton').data('pagecnt', '0');
        $('#loadButton').data('request', $(event.target).data('request'));

        loadMore.click($('#loadButton'));

        newBuildArtists.setActiveButton(event.target);

        //console.log('artistPageCreationsButtonPress', event.target);
    },
    setActiveButton: function(button) {
        $(button).closest('.row').find('.active').removeClass('active').removeClass('btn-gray').addClass('btn-outline-gray');
        $(button).removeClass('btn-outline-gray').addClass('active').addClass('btn-gray');
    },

    artistPageImageToggle: function(event) {
        event.preventDefault();
        event.stopPropagation();
        console.log('artistPageImageToggle');
        $('.artist_images [data-class]').each(function(index, item) {
            var toggleClass = $(item).data('class');
            if($(item).hasClass(toggleClass)) {
                $(item).removeClass(toggleClass);
            } else {
                $(item).addClass(toggleClass);
            }
            console.log(index, item);
        });
    },

}